import PropTypes from 'prop-types';

const AcademyTopicResourceType = PropTypes.shape({
  academy_module: PropTypes.object,
  title: PropTypes.string,
  lecture_bucket: PropTypes.object,
});

export default AcademyTopicResourceType;
